export const SERVER_URL = "https://moveapi.wsd.com.mx/api"
// export const SERVER_URL = "https://move-qa.wsd.com.mx/api"